import { render, staticRenderFns } from "./DevelopmentHistory.vue?vue&type=template&id=66b97c38&scoped=true"
import script from "./DevelopmentHistory.vue?vue&type=script&lang=js"
export * from "./DevelopmentHistory.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentHistory.vue?vue&type=style&index=0&id=66b97c38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b97c38",
  null
  
)

export default component.exports